import React from 'react'
import PropTypes from 'prop-types'
import {Box, Input, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {InputCheckIcon, InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'

const InputComponent = React.forwardRef((props, ref) => {
    const {
        isSuccess,
        isInvalid,
        tooltip,
        tooltipVariant,
        tooltipOpensOn,
        isProductRegistration,
        fillText,
        shouldRemoveLabel,
        value,
        hideSuccessIcon,
        placeholder = '',
        size,
        ...rest
    } = props

    let status = isSuccess
        ? 'success'
        : isInvalid
        ? 'invalid'
        : props.isDisabled
        ? 'disabled'
        : undefined

    const styles = useMultiStyleConfig('Field', {
        variant: status,
        size,
        shouldRemoveLabel,
        isProductRegistration,
    })
    const onChangeInProps = typeof onChange === 'function'

    const displayValue = onChangeInProps ? fillText : value
    const hasValue = displayValue && displayValue.length > 0
    const placeholderText = props.label || placeholder

    return (
        <Box __css={styles.container}>
            <Box
                sx={styles.input}
                py={hasValue ? '4px' : undefined}
                data-invalid={isInvalid || undefined}
                aria-disabled={props.isDisabled || undefined}
            >
                {hasValue && placeholderText && (
                    <Text {...styles.placeholderLabel} data-testid="placeholder-label">
                        {placeholderText}
                    </Text>
                )}
                <Input
                    ref={ref}
                    {...rest}
                    value={displayValue}
                    placeholder={placeholderText}
                    variant="unstyled"
                    autoComplete="off"
                    data-testid="input-component"
                    boxShadow={'none !important'}
                />
            </Box>

            {isSuccess && (
                <InputCheckIcon
                    {...{...styles.successIcon, display: hideSuccessIcon ? 'none' : 'block'}}
                />
            )}
            {tooltip && (
                <InfoPopover
                    trigger={<InfoIcon {...styles.infoIcon} />}
                    variant={tooltipVariant}
                    openTooltipOn={tooltipOpensOn}
                />
            )}
        </Box>
    )
})

InputComponent.displayName = 'InputComponent'
InputComponent.propTypes = {
    label: PropTypes.string,
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    inputType: PropTypes.string,
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipVariant: PropTypes.string,
    tooltipOpensOn: PropTypes.string,
    isSuccess: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    sx: PropTypes.object,
    fillText: PropTypes.string,
    shouldRemoveLabel: PropTypes.bool,
    value: PropTypes.string,
    rules: PropTypes.object,
    isProductRegistration: PropTypes.bool,
    'aria-label': PropTypes.string,
    borderColor: PropTypes.string,
    hideSuccessIcon: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'base', 'large', 'xl']),
}

export default InputComponent
